<template>
    <div
        class="rangeInput"
        @focus="startEdit"
        @blur="endEdit"
        tabindex="0"
    >
        {{internalValue}}
        <div v-if="internalValue !== ''" class="input-button backspace" @click="backspace"></div>
        <div v-if="internalValue !== ''" class="input-button clear" @click="clear"></div>
        <div v-if="inputBoxOpened" class="buttonBox">
            <div v-if="availableInputs.length === 0" class="info-text">{{$t('No available values')}}</div>
            <div v-else class="info-text">{{$t('Select model number:')}}</div>
            <div
                v-show="availableInputs.length"
                v-for="possibleInput in availableInputs"
                :key="possibleInput"
                @click="add(possibleInput)"
                class="button prevent-selection"
            >
                {{possibleInput}}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModelNumberInput",
    props: {
        pattern: [RegExp, String],
        value:   String,
    },
    data: function() {
        return {
            internalValue:  this.value,
            inputBoxOpened: false,
            autoAddOnlyValue: false
        };
    },
    watch: {
        availableInputs(value) {
            if (
                this.autoAddOnlyValue
                && value.length === 1
                && this.internalValue !== ''
            ) {
                this.add(value[0]);
            }
        }
    },
    computed: {
        availableInputs() {
            let available = [];
            let match;
            for (let i=32; i<122; i++) {
                let char = String.fromCharCode(i);
                let currentTest = this.internalValue + char;
                match = currentTest.match(this.pattern);

                if (
                    Array.isArray(match)
                    && match[0].length > 0
                    && match.index === 0
                ) {
                    available.push(char);
                }
            }

            if (available.length > 80) {
                available = [];
            }

            return available;
        }
    },
    methods: {
        startEdit() {
            this.autoAddOnlyValue = false;
            this.inputBoxOpened = true;
        },
        endEdit() {
            this.autoAddOnlyValue = false;
            this.inputBoxOpened = false;
            this.$emit('input', this.internalValue);
        },
        add(value) {
            this.autoAddOnlyValue = true;
            this.internalValue += value;
        },
        backspace() {
            this.autoAddOnlyValue = false;
            this.internalValue = this.internalValue.slice(0, -1);
        },
        clear() {
            this.autoAddOnlyValue = false;
            this.internalValue = '';
        },
        getNextAvailableInputChar()
        {

        },
    }
    /*
    * What do we need?
    * An Input box with buttons for available inputs
    * -> a function which returns the available inputs
    * -> if only one input is available, use it directly without button click
    *
    *
    * */
}
</script>

<style scoped>
    div.rangeInput {
        display: inline-block;
        background-color: var(--sc-blue-light-background);
        width: 200px;
        padding: 4px;
        font-size: 10pt;
        height: 28px;
        border: 1px solid var(--sc-blue-light);
        vertical-align: middle;
        position: relative;
    }
    div.rangeInput div.input-button {
        display: inline-block;
        width: 16px;
        height: 16px;
        background-size: 18px 18px;
        background-position: center;
        top: 5px;
        position: absolute;
        cursor: pointer;
    }
    div.rangeInput div.backspace {
        background-image: url('../../assets/icons/tags/backspace.svg');
        right: 19px;
        background-size: 12px;
    }
    div.rangeInput div.clear {
        background-image: url('../../assets/icons/replacements/close.svg');
        right: 3px;
    }

    div.buttonBox {
        border: 1px solid var(--sc-blue-dark);
        background-color: var(--sc-blue-light-background);
        position: relative;
        top: 25px;
        z-index: 150;
        left: -5px;
        padding: 15px;
        font-size: 11pt;
    }

    div.buttonBox div.info-text {
        margin-bottom: 8px;
    }

    div.buttonBox div.button {
        border: 1px solid var(--sc-blue-light);
        background-color: var(--sc-blue-light-background);
        display: inline-block;
        width: 32px;
        height: 32px;
        font-weight: bold;
        text-align: center;
        padding: 4px;
        box-shadow: 2px 2px 4px grey;
        margin-right: 8px;
        margin-bottom: 8px;
    }

    div.buttonBox div.button:hover {
        background-color: var(--sc-blue-light);
        cursor: pointer;
    }
</style>